/* import __COLOCATED_TEMPLATE__ from './feature-gate-not.hbs.js'; */
import FeatureGateBase from './feature-gate-base';
export default class FeatureGateNot extends FeatureGateBase {
  get showContent() {
    if (this.isLoading) {
      return false;
    }
    if (this.isError) {
      return !this.args.fallbackFeatureEntitlement;
    }
    return !this.isEntitledToFeature;
  }
}